import { render, staticRenderFns } from "./MediaFilesModal.vue?vue&type=template&id=67c23312&"
import script from "./MediaFilesModal.vue?vue&type=script&lang=js&"
export * from "./MediaFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./MediaFilesModal.vue?vue&type=style&index=0&id=67c23312&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports